module.exports = __webpack_public_path__ + "static/media/aptor_logo.5cc500a9.svg";